import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetByIdLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_EDIT_LOTTERY
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetViewLotteryAction({
                    id: data.data.id,
                    start: data.data.date_from,
                    end: data.data.date_to,
                    label_name: data.data.label,
                    description: data.data.description,
                    fund: data.data.fund,
                    count_winners: data.data.count_winners,
                    winners: data.data.top_places,
                    price_ticket_deposit: data.data.price_ticket_deposit,
                    price_ticket: data.data.price_ticket,
                    gold_ticket: data.data.gold_ticket,
                    status: data.data.status
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetByIdLottery as SetGetByIdLottery
}